import React, { useRef, useEffect } from "react";

interface AutoPlaySilentVideoProps {
  className?: string;
  video: string;
}

const AutoPlaySilentVideo: React.FC<AutoPlaySilentVideoProps> = ({
  className,
  video,
}) => {
  const videoRef = useRef<HTMLVideoElement | null>(null);

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.defaultMuted = true;
    }
  }, []);

  return (
    <video className={className} ref={videoRef} loop autoPlay muted playsInline>
      <source src={video} type="video/mp4" />
    </video>
  );
};

export default AutoPlaySilentVideo;
